import { createRouter } from "@tanstack/react-router";

import { ErrorPane } from "./routes/-error";
import { PendingPane } from "./routes/-pending";
import { routeTree } from "./routeTree.gen";

export const router = createRouter({
  routeTree,
  defaultPendingComponent: PendingPane,
  // Show the skeleton quickly on cold lazy-chunk loads. The router still
  // waits `defaultPendingMinMs` (500ms default) before tearing it down, so
  // fast transitions won't flash.
  defaultPendingMs: 150,
  // Render ErrorPane at the route match level so a thrown child route
  // (e.g. /_workspace/files/$) replaces only the route's own output —
  // the workspace shell (header, side pane, sheets) stays mounted.
  defaultErrorComponent: ErrorPane,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
